export const ApplicantLoginTranslations = {
    en: {
        login: {
            title: 'Applicant Login',
            tabLogin: 'Login',
            tabRegister: 'Register',
            closeButton: 'Close login form',
            emailLabel: 'Email',
            emailPlaceholder: 'your@email.com',
            passwordLabel: 'Password',
            passwordPlaceholder: '••••••••',
            loginButton: 'Login',
            cancelButton: 'Cancel',
            loggingIn: 'Logging in...',
            forgotPassword: 'Forgot your password?',
            successMessage: 'Login successful! Redirecting...',
            "instructionsTitle": "General Instructions",
            "instruction1": "Since all the applications will be screened on the basis of data submitted by the applicant, it is advised to submit correct information.",
            "instruction2": "If at any stage during the process, it is found that the applicant has furnished incomplete or false or wrong information, their application will be rejected.",
            "instruction3": "You must possess a valid e-mail ID for applying online as the same will be used for future correspondence with you. Please create a new email ID, if you do not have one, prior to filling up an online application.",
            "instruction4": "In case, an applicant has previously applied online for any application for availing any online service (part plan or zone certificate), in order to apply for a fresh application for availing any service, the applicant is required to apply online using a same USER NAME and E-MAIL ID (rest all details can be the same). Applicants need not register again.",
            "okButton": "OK",
            "closeInstructions": "Close instructions",
            errors: {
                usernameRequired: 'Username is required',
                validEmail: 'Please enter a valid email',
                passwordRequired: 'Password is required',
                passwordLength: 'Password must be at least 6 characters',
                loginFailed: 'Login failed. Please try again.',
                invalidCredentials: 'Invalid credentials. Please try again.'
            }
        },

    },
    mr: {

        login: {
            title: 'अर्जदार लॉगिन',
            tabLogin: 'लॉगिन',
            tabRegister: 'नोंदणी',
            closeButton: 'लॉगिन फॉर्म बंद करा',
            emailLabel: 'ईमेल',
            emailPlaceholder: 'तुमचा@ईमेल.कॉम',
            passwordLabel: 'पासवर्ड',
            passwordPlaceholder: '••••••••',
            loginButton: 'लॉगिन',
            cancelButton: 'रद्द करा',
            loggingIn: 'लॉगिन होत आहे...',
            forgotPassword: 'पासवर्ड विसरलात?',
            successMessage: 'लॉगिन यशस्वी! पुनर्निर्देशित करत आहे...',
            "instructionsTitle": "सामान्य सूचना",
            "instruction1": "अर्जदाराने सादर केलेल्या डेटाच्या आधारे सर्व अर्ज तपासले जात असल्याने, योग्य माहिती सादर करण्याचा सल्ला दिला जातो.",
            "instruction2": "जर प्रक्रियेदरम्यान कोणत्याही टप्प्यावर असे आढळले की अर्जदाराने अपूर्ण किंवा खोटी किंवा चुकीची माहिती सादर केली आहे, तर त्यांचा अर्ज नाकारला जाईल.",
            "instruction3": "ऑनलाइन अर्ज करण्यासाठी तुमच्याकडे एक वैध ई-मेल आयडी असणे आवश्यक आहे कारण तुमच्याशी पुढील पत्रव्यवहारासाठी तेच वापरले जाईल. ऑनलाइन अर्ज भरण्यापूर्वी, तुमच्याकडे नसल्यास, कृपया एक नवीन ईमेल आयडी तयार करा.",
            "instruction4": "जर अर्जदाराने आधी कोणत्याही ऑनलाइन सेवेसाठी (भाग योजना किंवा झोन प्रमाणपत्र) ऑनलाइन अर्ज केला असेल, तर कोणत्याही सेवेचा लाभ घेण्यासाठी नवीन अर्ज करण्यासाठी, अर्जदाराला समान वापरकर्तानाव आणि ई-मेल आयडी वापरून ऑनलाइन अर्ज करणे आवश्यक आहे (इतर सर्व तपशील समान असू शकतात). अर्जदारांना पुन्हा नोंदणी करण्याची आवश्यकता नाही.",
            "okButton": "ठीक आहे",
            "closeInstructions": "सूचना बंद करा",
            errors: {
                usernameRequired: 'वापरकर्तानाव आवश्यक आहे',
                validEmail: 'कृपया वैध ईमेल टाका',
                passwordRequired: 'पासवर्ड आवश्यक आहे',
                passwordLength: 'पासवर्ड किमान ६ वर्णांचा असावा',
                loginFailed: 'लॉगिन अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
                invalidCredentials: 'अवैध प्रमाणपत्रे. कृपया पुन्हा प्रयत्न करा.'
            }
        },
    }
};
